<template>
  <div>
    <v-select
      v-model="inputedValue"
      item-text="label"
      item-value="value"
      :items="items"
      dense
      outlined
      return-object
      class="original-selectbox"
      hide-details
      :placeholder="$t('common.input_unselected_2')"
      :height="height"
      :no-data-text="$t('common.common_not-register')"
      clearable
    >
    </v-select>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { platformUtil } from '@/util'

export default {
  components: {
    //
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => ({})
    },
    height: {
      type: String,
      require: false,
      default: '32px'
    },
    filterCountry: {
      default: {}
    }
  },
  data: () => ({
    items: []
  }),
  async created() {
    await this.init()
  },
  methods: {
    ...mapActions('Platform', ['getPlatformListFromApi']),
    async init() {
      await this.getPlatformListFromApi()
      this.items = platformUtil.getPlatfomrListForSelectBox()
    }
  },
  computed: {
    ...mapGetters('Platform', ['getPlatformListFromState']),
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    filterCountry: {
      deep: true,
      handler() {
        if (!this.filterCountry || !this.filterCountry.value || !this.items) {
          this.items = platformUtil.getPlatfomrListForSelectBox()
          return
        }
        this.items = platformUtil
          .getPlatfomrListForSelectBox()
          .filter((ele) => ele.platformCountryId == this.filterCountry.value)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
